import { render, staticRenderFns } from "./SubmitContentList.vue?vue&type=template&id=3d8fc3cb&"
import script from "./SubmitContentList.vue?vue&type=script&lang=js&"
export * from "./SubmitContentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports